import { forwardRef } from 'react';
import SelectInternal from './select-internal';
const Select = forwardRef(SelectInternal);
export default Select;
